__turbopack_context__.v({
  "panelCenter": "DeliveryCenterPanel-module__Ayy6rq__panelCenter",
});
